import Vue from "vue"
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from "vuetify/lib"
import EvaIcons from 'vue-eva-icons'
import VueTablerIcons from 'vue-tabler-icons'
import Building02 from '@/assets/icons/Building02.vue'
import BellRinging04 from '@/assets/icons/BellRinging04.vue'
import CoinsHand from '@/assets/icons/CoinsHand.vue'
import BookClosed from '@/assets/icons/BookClosed.vue'
import QrCode02 from '@/assets/icons/QrCode02.vue'
import Receipt from '@/assets/icons/Receipt.vue'
import Edit02 from '@/assets/icons/Edit02.vue'
import FilterLine from '@/assets/icons/FilterLine.vue'
import Settings02 from '@/assets/icons/Settings02.vue'
import Announcement03 from '@/assets/icons/Announcement03.vue'
import User02 from '@/assets/icons/User02.vue'
import User03 from '@/assets/icons/User03.vue'
import Users02 from '@/assets/icons/Users02.vue'
import UserCircle from '@/assets/icons/UserCircle.vue'
import UserEdit from '@/assets/icons/UserEdit.vue'
import Upload01 from '@/assets/icons/Upload01.vue'
import Download01 from '@/assets/icons/Download01.vue'
import Trash04 from '@/assets/icons/Trash04.vue'
import Trash03 from '@/assets/icons/Trash03.vue'
import Calendar from '@/assets/icons/Calendar.vue'
import Hourglass03 from '@/assets/icons/Hourglass03.vue'
import UserPlus01 from '@/assets/icons/UserPlus01.vue'
import Mail01 from '@/assets/icons/Mail01.vue'
import MessageCircle01 from '@/assets/icons/MessageCircle01.vue'
import ChevronDown from '@/assets/icons/ChevronDown.vue'
import AlertCircleSolid from '@/assets/icons/AlertCircleSolid.vue'
import CheckCircle from '@/assets/icons/CheckCircle.vue'
import CheckCircleSolid from '@/assets/icons/CheckCircleSolid.vue'
import GoogleIcon from '@/assets/icons/GoogleIcon.vue'
import Plus from '@/assets/icons/Plus.vue'
import Copy03 from '@/assets/icons/Copy03.vue'
import MedicalCross from '@/assets/icons/MedicalCross.vue'
import DotsGrid02 from '@/assets/icons/DotsGrid02.vue'
import Lock03 from '@/assets/icons/Lock03.vue'
import SearchSm from '@/assets/icons/SearchSm.vue'
import FilterFunnel01 from '@/assets/icons/FilterFunnel01.vue'
import ChevronUp from '@/assets/icons/ChevronUp.vue'
import Automatic from '@/assets/icons/Automatic.vue'
import List from '@/assets/icons/List.vue'
import Triangle from '@/assets/icons/Triangle.vue'
import DataFlow01 from '@/assets/icons/DataFlow01.vue'
import Star04 from '@/assets/icons/Star04.vue'
import ThumbsUp from '@/assets/icons/ThumbsUp.vue'
import Star01 from '@/assets/icons/Star01.vue'
import Star01Fill from '@/assets/icons/Star01Fill.vue'
import IosBatteryFull from '@/assets/icons/IosBatteryFull.vue'
import IosSafariSafeLock from '@/assets/icons/IosSafariSafeLock.vue'
import IosSafariReplyArrow from '@/assets/icons/IosSafariReplyArrow.vue'
import GmailIcon from '@/assets/icons/GmailIcon.vue'
import CheckVerified02 from '@/assets/icons/CheckVerified02.vue'
import MessageSquare02 from '@/assets/icons/MessageSquare02.vue'
import Menu03 from '@/assets/icons/Menu03.vue'
import Menu05 from '@/assets/icons/Menu05.vue'
import Phone from '@/assets/icons/Phone.vue'
import Dotpoints02 from '@/assets/icons/Dotpoints02.vue'
import Markerpin02 from '@/assets/icons/Markerpin02.vue'
import Mail02 from '@/assets/icons/Mail02.vue'
import Number123 from '@/assets/icons/123.vue'
import AlarmClock from '@/assets/icons/AlarmClock.vue'
import ArrowUp from '@/assets/icons/ArrowUp.vue'
import ArrowDown from '@/assets/icons/ArrowDown.vue'
import User01 from '@/assets/icons/User01.vue'
import Key02 from '@/assets/icons/Key02.vue'
import Copy02 from '@/assets/icons/Copy02.vue'
import ArrowNarrowLeft from '@/assets/icons/ArrowNarrowLeft.vue'

Vuetify.config.silent = true
Vue.use(EvaIcons)
Vue.use(Vuetify)
Vue.use(VueTablerIcons)

export default new Vuetify({
  treeShake: true,
  theme: {
    dark: false,
    themes: {
      light: {
        // text color
        textColor: '#222B45',
        textColorDefault: '#222B45',
        textColorAccent: '#3366FF',
        textColorAlternative: '#FFFFFF',
        textColorHint: '#8F9BB3',
        textColorDisabled: '#8F9BB380',
        textColorZoo: '#6231DB',
        // primary
        primary: '#333333',
        primaryT08: '#33333314',
        primaryT16: '#33333329',
        primaryT24: '#3333333D',
        primaryT32: '#33333352',
        primaryT40: '#33333366',
        primaryT48: '#3333337A',
        primary100: '#F4F4F4',
        primary200: '#EAEAEA',
        primary300: '#C1C1C1',
        primary400: '#848484',
        primary500: '#333333',
        primary600: '#2B2525',
        primary700: '#24191B',
        primary800: '#1D1013',
        primary900: '#18090E',
        // basic
        basic: '#C1C1C1',
        basic100: '#FFFFFF',
        basic100T08: '#FFFFFF14',
        basic100T16: '#FFFFFF29',
        basic100T24: '#FFFFFF3D',
        basic100T32: '#FFFFFF52',
        basic100T40: '#FFFFFF66',
        basic100T48: '#FFFFFF7A',
        basic100T64: '#FFFFFFA3',
        basic200: '#F7F7F7',
        basic300: '#F4F4F4',
        basic400: '#EAEAEA',
        basic500: '#C1C1C1',
        basic600: '#848484',
        basic600T08: '#8F9BB314',
        basic600T16: '#8F9BB329',
        basic600T24: '#8F9BB33D',
        basic600T32: '#8F9BB352',
        basic600T40: '#8F9BB366',
        basic600T48: '#8F9BB37A',
        basic700: '#333333',
        basic800: '#2B2525',
        basic900: '#24191B',
        basic1000: '#1D1013',
        basic1100: '#18090E',
        // success
        success: '#009966',
        successT08: '#00996614',
        successT16: '#00996629',
        successT24: '#0099663D',
        successT32: '#00996652',
        successT40: '#00996666',
        successT48: '#0099667A',
        success100: '#C7F9D5',
        success200: '#92F4B7',
        success300: '#59E099',
        success400: '#30C183',
        success500: '#009966',
        success600: '#008364',
        success700: '#006E5F',
        success800: '#005855',
        success900: '#004449',
        // info
        info: '#3366FF',
        infoT08: '#3366FF14',
        infoT16: '#3366FF29',
        infoT24: '#3366FF3D',
        infoT32: '#3366FF52',
        infoT40: '#3366FF66',
        infoT48: '#3366FF7A',
        info100: '#D6E4FF',
        info200: '#ADC8FF',
        info200T08: '#ADC8FF14',
        info200T16: '#ADC8FF29',
        info200T24: '#ADC8FF3D',
        info200T32: '#ADC8FF52',
        info200T40: '#ADC8FF66',
        info200T48: '#ADC8FF7A',
        info300: '#84A9FF',
        info400: '#6690FF',
        info500: '#3366FF',
        info600: '#254EDB',
        info700: '#1939B7',
        info800: '#102693',
        info900: '#091A7A',
        // warning
        warning: '#FFCC00',
        warningT08: '#FFCC0014',
        warningT16: '#FFCC0029',
        warningT24: '#FFCC003D',
        warningT32: '#FFCC0052',
        warningT40: '#FFCC0066',
        warningT48: '#FFCC007A',
        warning100: '#FFF9CC',
        warning200: '#FFF099',
        warning300: '#FFE666',
        warning400: '#FFDC3F',
        warning500: '#FFCC00',
        warning600: '#DBAA00',
        warning700: '#B78B00',
        warning800: '#936D00',
        warning900: '#7A5700',
        // danger
        danger: '#CD3300',
        dangerT08: '#CD330014',
        dangerT16: '#CD330029',
        dangerT24: '#CD33003D',
        dangerT32: '#CD330052',
        dangerT40: '#CD330066',
        dangerT48: '#CD33007A',
        danger100: '#FCE4C9',
        danger200: '#F9C495',
        danger300: '#EF985F',
        danger400: '#E06E38',
        danger500: '#CD3300',
        danger600: '#AF1F00',
        danger700: '#920F00',
        danger800: '#760400',
        danger900: '#610003',
        //zoo
        zooPurple: '#6231DB',
        zooPurpleT10: '#6231DB1A',
        // YCE
        neutral100: '#FFFFFF',
        neutral200: '#F9FAFB',
        neutral300: '#EEEEEE',
        neutral400: '#C1C1C1',
        neutral500: '#848484',
        neutral700: '#333333',
      },
    },
  },
  icons: {
    values: {
      'yzi-building-02': { component: Building02 },
      'yzi-bell-ringing-04': { component: BellRinging04 },
      'yzi-coins-hand': { component: CoinsHand },
      'yzi-receipt': { component: Receipt },
      'yzi-qr-code-02': { component: QrCode02 },
      'yzi-book-closed': { component: BookClosed },
      'yzi-edit-02': { component: Edit02 },
      'yzi-filter-line': { component: FilterLine },
      'yzi-settings-02': { component: Settings02 },
      'yzi-user-02': { component: User02 },
      'yzi-user-03': { component: User03 },
      'yzi-users-02': { component: Users02 },
      'yzi-user-circle': { component: UserCircle },
      'yzi-user-edit': { component: UserEdit },
      'yzi-upload-01': { component: Upload01 },
      'yzi-download-01': { component: Download01 },
      'yzi-trash-04': { component: Trash04 },
      'yzi-trash-03': { component: Trash03 },
      'yzi-calendar': { component: Calendar },
      'yzi-announcement-03': { component: Announcement03 },
      'yzi-hourglass-03': { component: Hourglass03 },
      'yzi-userplus-03': { component: UserPlus01 },
      'yzi-mail-01': { component: Mail01 },
      'yzi-message-circle-01': { component: MessageCircle01 },
      'yzi-chevron-down': { component: ChevronDown },
      'yzi-alert-circle-solid': { component: AlertCircleSolid },
      'yzi-check-circle': { component: CheckCircle },
      'yzi-check-circle-solid': { component: CheckCircleSolid },
      'yzi-copy-03': { component: Copy03 },
      'yzi-plus': { component: Plus },
      'yzi-medical-cross': { component: MedicalCross },
      'yzi-dots-grid-02': { component: DotsGrid02 },
      'yzi-lock-03': { component: Lock03 },
      'yzi-google-icon': { component: GoogleIcon },
      'yzi-search-sm': { component: SearchSm },
      'yzi-filter-funnel-01': { component: FilterFunnel01 },
      'yzi-chevron-up': { component: ChevronUp },
      'yzi-automatic': { component: Automatic },
      'yzi-list': { component: List },
      'yzi-triangle': { component: Triangle },
      'yzi-data-flow-01': { component: DataFlow01 },
      'yzi-star-04': { component: Star04 },
      'yzi-thumbs-up': { component: ThumbsUp },
      'yzi-star-01': { component: Star01 },
      'yzi-star-01-fill': { component: Star01Fill },
      'yzi-ios-battery-full': { component: IosBatteryFull },
      'yzi-ios-safari-safe-lock': { component: IosSafariSafeLock },
      'yzi-ios-safari-reply-arrow': { component: IosSafariReplyArrow },
      'yzi-gmail-icon': { component: GmailIcon },
      'yzi-check-verified-02': { component: CheckVerified02 },
      'yzi-message-square-02': { component: MessageSquare02 },
      'yzi-menu-03': { component: Menu03 },
      'yzi-menu-05': { component: Menu05 },
      'yzi-phone': { component: Phone },
      'yzi-dotpoints-02': { component: Dotpoints02 },
      'yzi-markerpin-02': { component: Markerpin02 },
      'yzi-mail-02': { component: Mail02 },
      'yzi-123': { component: Number123 },
      'yzi-alarm-clock': { component: AlarmClock },
      'yzi-arrow-up': { component: ArrowUp },
      'yzi-arrow-down': { component: ArrowDown },
      'yzi-user-01': { component: User01 },
      'yzi-key-02': { component: Key02 },
      'yzi-copy-02': { component: Copy02 },
      'yzi-arrow-narrow-left': { component: ArrowNarrowLeft },
    },
  },
})